import {ModuleWithProviders, NgModule} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {RouterModule} from '@angular/router';
import {FuseSharedModule} from '@fuse/shared.module';
import {GarLoginComponent} from '@modules/authentication/core/login/gar-login/gar-login.component';
import {LoginFormComponent} from '@modules/authentication/core/login/login-form/login-form.component';
import {LoginLogoComponent} from '@modules/authentication/core/login/login-logo/login-logo.component';
import {PartnersLogosComponent} from '@modules/authentication/core/login/partners-logos/partners-logos.component';
import {RegisterLinkComponent} from '@modules/authentication/core/login/register-link/register-link.component';
import {SsoLoginComponent} from '@modules/authentication/core/login/sso-login/sso-login.component';
import {routes} from '@modules/authentication/core/routes';
import {SharedModule} from 'shared/shared.module';
import {AuthenticationService} from './authentication.service';
import {FuseLoginComponent} from './login/login.component';
import {SessionsListComponent} from './login/sessions-list/sessions-list.component';
import {UpdateMailDialogComponent} from './update-mail-dialog/update-mail-dialog.component';

@NgModule({
    imports: [
        FuseSharedModule,
        SharedModule,
        RouterModule.forChild(routes),
        MatProgressSpinnerModule,
        RegisterLinkComponent,
        SsoLoginComponent,
        GarLoginComponent,
        LoginLogoComponent,
        PartnersLogosComponent,
        LoginFormComponent
    ],
    declarations: [
        FuseLoginComponent,
        UpdateMailDialogComponent,
        SessionsListComponent
    ],
    providers: [],
    exports: [RouterModule, SessionsListComponent]
})
export class AuthenticationModule {

    static forRoot(): ModuleWithProviders<AuthenticationModule> {

        return {
            ngModule: AuthenticationModule,
            providers: [
                AuthenticationService
            ]
        };
    }
}